import breakpoints from './breakpoints';

export { breakpoints };
